<template>
  <section v-if="links.length" class="v2-card" qid="home-guides">
    <div class="v2-card__head"><h3>{{ $t('home.guides.title') }}</h3></div>
    <a
        v-for="guide in links"
        :key="guide.key"
        :href="guide.url"
        target="_blank"
        rel="noopener"
        class="home-guide"
        :title="$t('home.guides.new_tab')"
        :qid="'home-guide-' + guide.key"
    >
      <span class="home-guide__icon"><font-awesome-icon :icon="guide.icon"/></span>
      <span class="grow">
        <span class="home-guide__name">{{ $t('home.guides.' + guide.key) }}</span>
        <span class="home-guide__text">{{ $t('home.guides.' + guide.key + '_text') }}</span>
      </span>
      <font-awesome-icon icon="up-right-from-square" class="home-guide__ext"/>
    </a>
  </section>
</template>

<script>
// The Help Center guides; the Home API says which ones fit the user
const GUIDES = {
  auditor: { url: 'https://complyon.com/help/auditor-user-guide/', icon: 'book-open' },
  documentation_collection: { url: 'https://complyon.com/help/documentation-collection-guide/', icon: 'folder-open' }
};

export default {
  name: 'HomeGuides',
  props: {
    guides: { type: Array, default: () => [] }
  },
  computed: {
    links() {
      return this.guides.filter(key => GUIDES[key]).map(key => Object.assign({ key }, GUIDES[key]));
    }
  }
};
</script>
